module.exports = __webpack_public_path__ + "media/images/butterfly-4a020ed34172ea6f8a21124945c5486e.png";